export default "__VITE_ASSET__DHUMmfob__"